export const requestsConstants = {
    LIST_REQUEST: 'REQUEST_LIST_REQUEST',
    LIST_SUCCESS: 'REQUEST_LIST_SUCCESS',
    LIST_FAILURE: 'REQUEST_LIST_FAILURE',

    ITEM_REQUEST: 'REQUEST_ITEM_REQUEST',
    ITEM_SUCCESS: 'REQUEST_ITEM_SUCCESS',
    ITEM_FAILURE: 'REQUEST_ITEM_FAILURE',

    ADD_COMMENT_REQUEST: 'REQUEST_ADD_COMMENT_REQUEST',
    ADD_COMMENT_SUCCESS: 'REQUEST_ADD_COMMENT_SUCCESS',
    ADD_COMMENT_FAILURE: 'REQUEST_ADD_COMMENT_FAILURE',

    NOTIFICATION: 'REQUEST_NOTIFICATION',

    RESET: 'REQUEST_RESET'
};